export const GENDER_OPTIONS = [
  ['', 'Ej angivet', 'Not specified'],
  ['female', 'Kvinna', 'Female'],
  ['male', 'Man', 'Male'],
  ['other', 'Annat', 'Other'],
];
export function genderLabel(value, tr = a => a) {
  const item = GENDER_OPTIONS.find(([key]) => key === (value || ''));
  return item ? tr(item[1], item[2]) : tr('Behöver granskas', 'Needs review');
}
